import { FC, ReactNode } from "react";

export interface AccardionItemProps {
  title?: string;
  accStyle?: string;
  children?: ReactNode;
}

const AccardionItem: FC<AccardionItemProps> = ({ children, ...props }) => {
  return (
    <details
      className="block my-4"
      onToggle={(e) => {
        if ((e.target as any).open) {
          document.querySelectorAll("details")?.forEach((f) => {
            if (f != e.target && f.open) f.open = false;
          });
        }
      }}
    >
      <summary className="bg-[#f0f0f0] cursor-pointer  list-item rounded-[10px] border-b border-[#ccc] py-[7px] px-[5px]">
        <strong>{props.title}</strong>
      </summary>
      <div className="border border-[#ccc] pt-6 px-5 pb-5 rounded-[10px]">
        {children}
      </div>
    </details>
  );
};

export default AccardionItem;
